import { render, staticRenderFns } from "./BaseNavOnlineStore.vue?vue&type=template&id=6283863b"
import script from "./BaseNavOnlineStore.vue?vue&type=script&lang=js"
export * from "./BaseNavOnlineStore.vue?vue&type=script&lang=js"
import style0 from "./BaseNavOnlineStore.vue?vue&type=style&index=0&id=6283863b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports